
export default {
  state: {
    automation: {
      edit: {
        needsSaving: false
      }
    },
    email: {
      isContentSaving: false, 
      create: {
        step: 1,
        data: {
          title: undefined,
          isAutomationFlow: undefined,
          model: {
            htmlContent: undefined, 
            cssStyle: undefined, 
            editorType: undefined 
          },
        },
        item: undefined,
          
      },
      edit: {
        step: 1,
        isAutomationFlow: false,
        emailId: undefined,
        editorType: undefined,
        viewOnly: false
      }
    }
  },

  mutations: {
    SET_EMAIL_CREATE_STEP(state, step) {
      state.email.create.step = step;
    },
    EMAIL_CREATE_SET_MODEL(state, model) {
      state.email.create.data.model = model;
    },
    EMAIL_CREATE_SET_TITLE(state, title) {
      state.email.create.data.title = title;
    },
    EMAIL_CREATE_SET_AUTOMATION(state, isAutomationFlow) {
      state.email.create.data.isAutomationFlow = isAutomationFlow;
    },
    EMAIL_CREATE_SET_ITEM(state, item) {
      state.email.create.item = item;
      addInfoToEmailDataInSessionStorage(item)
    },
    EMAIL_EDIT_SET_AUTOMATION(state, isAutomationFlow) {
      state.email.edit.isAutomationFlow = isAutomationFlow;
    },
    SET_EMAIL_EDIT_STEP(state, step) {
      state.email.edit.step = step;
    },
    SET_EMAIL_CONTENT_SAVING(state, isContentSaving) {
      state.email.isContentSaving = isContentSaving;
    },
    SET_EMAIL_EDIT_ID(state, emailId) {
      state.email.edit.emailId = emailId;
    },
    SET_EMAIL_EDIT_EDITOR_TYPE(state, editorType) {
      state.email.edit.editorType = editorType;
    },
    SET_AUTOMATION_EDIT_NEEDS_SAVING(state, needsSaving) {
      state.automation.edit.needsSaving = needsSaving;
    },
    SET_EMAIL_EDIT_IS_VIEW(state, viewOnly) {
      state.email.edit.viewOnly = viewOnly;
    },    
  }  
};

function addInfoToEmailDataInSessionStorage(data) {
  if(data) {   
    const emailData = JSON.parse(sessionStorage.getItem("email_data"));
    const emailItem = JSON.parse(sessionStorage.getItem("email_item"));
    if(emailItem) {      
      const newEmailItem = Object.assign(emailItem, data)
      sessionStorage.setItem("email_item", JSON.stringify(newEmailItem))
    } else {
      const emailItemWithData = Object.assign(data, emailData)
      sessionStorage.setItem("email_item", JSON.stringify(emailItemWithData))
    }
  } 
}
